"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var report_table_view_parser_1 = require("./service/report-table-view.parser");
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
var report_deserializer_1 = require("../common/report-deserializer");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var view_event_service_1 = require("./service/view-event.service");
var idm_reporting_controls_1 = require("@synisys/idm-reporting-controls");
var rows_change_event_type_1 = require("./model/event/rows-change-event-type");
var columns_change_event_type_1 = require("./model/event/columns-change-event-type");
var report_view_styles_deserializer_1 = require("../common/model/style/report-view-styles-deserializer");
var report_view_styles_1 = require("../common/model/style/report-view-styles");
var reference_number_resolver_1 = require("../sis-tabular-report-options/resolver/reference-number-resolver");
var SisTabularReportDesignerComponent = /** @class */ (function () {
    function SisTabularReportDesignerComponent(viewEventService, cdRef) {
        var _this = this;
        this.viewEventService = viewEventService;
        this.cdRef = cdRef;
        this.initialized = false;
        this._dataSetId = null;
        this._subscriptions = [];
        this._references = new Array();
        this.viewState = new core_1.EventEmitter();
        this._subscriptions.push(this.viewEventService.columnsChange$.filter(function (event) {
            return event.type === columns_change_event_type_1.ColumnsChangeEventType.COLUMN_ADDED || event.type === columns_change_event_type_1.ColumnsChangeEventType.COLUMN_REMOVED ||
                event.type === columns_change_event_type_1.ColumnsChangeEventType.COLUMN_MOVED;
        }).subscribe(function () {
            _this.viewEventService.reportChanged(_this._reportTableView, _this._dataSetId);
        }));
        this._subscriptions.push(this.viewEventService.rowsChange$.filter(function (event) {
            return event.type === rows_change_event_type_1.RowsChangeEventType.ROW_CREATED || (event.type === rows_change_event_type_1.RowsChangeEventType.ROW_REMOVED && event.withAnimations);
        }).subscribe(function () {
            _this.viewEventService.reportChanged(_this._reportTableView, _this._dataSetId);
        }));
        this._subscriptions.push(this.viewEventService.additionalOptionsChange$.subscribe(function (event) {
            _this._title = event.title;
        }));
        this._subscriptions.push(this.viewEventService.styleChange$.subscribe(function (event) {
            _this._references = reference_number_resolver_1.ReferenceNumberResolver.getReferences(_this._reportTableView);
        }));
    }
    SisTabularReportDesignerComponent.prototype.ngOnChanges = function (changes) {
        if (changes && changes['fullState']) {
            var report = this.extractReportJson();
            var reportViewStyles = this.extractReportViewStyles();
            if (this._previousReportDto && JSON.stringify(this._previousReportDto) === JSON.stringify(report)) {
                // in case report structure is not changed, only fill styles to existing one
                report_table_view_parser_1.ReportTableViewParser.fillStyles(this._reportTableView, reportViewStyles);
            }
            else {
                this._reportTableView = new report_table_view_parser_1.ReportTableViewParser(report, reportViewStyles).parse();
            }
            this.viewEventService.reportSetup(this._reportTableView, this._dataSetId);
            this._references = reference_number_resolver_1.ReferenceNumberResolver.getReferences(this._reportTableView);
            this._datasetSelected = this._dataSetId !== null;
            this._previousReportDto = report;
        }
    };
    SisTabularReportDesignerComponent.prototype.ngOnDestroy = function () {
        this._subscriptions.forEach(function (s) { return s.unsubscribe(); });
    };
    SisTabularReportDesignerComponent.prototype.ngAfterViewInit = function () {
        this.initialized = true;
        this.cdRef.detectChanges();
    };
    Object.defineProperty(SisTabularReportDesignerComponent.prototype, "title", {
        get: function () {
            return this._title;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTabularReportDesignerComponent.prototype, "dataSetId", {
        get: function () {
            return this._dataSetId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTabularReportDesignerComponent.prototype, "datasetSelected", {
        get: function () {
            return this._datasetSelected;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTabularReportDesignerComponent.prototype, "reportTableView", {
        get: function () {
            return this._reportTableView;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SisTabularReportDesignerComponent.prototype, "references", {
        get: function () {
            return this._references;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Extracts report from full report json
     */
    SisTabularReportDesignerComponent.prototype.extractReportJson = function () {
        if (this.fullState) {
            var jsonObject = typeof this.fullState === 'string' ? JSON.parse(this.fullState) : this.fullState;
            this._dataSetId = jsonObject.dataSetId ? jsonObject.dataSetId : null;
            this._title = jsonObject.title ? idm_reporting_controls_1.MultilingualTypeHelper.deserializeMultilingualString(jsonObject.title) : null;
            return (jsonObject.state && jsonObject.state.report) ? report_deserializer_1.ReportDeserializer.fromJson(jsonObject.state.report) : new idm_reporting_service_client_js_1.ReportDtoBuilder().build();
        }
        else {
            this._title = null;
            this._dataSetId = null;
            return new idm_reporting_service_client_js_1.ReportDtoBuilder().build();
        }
    };
    SisTabularReportDesignerComponent.prototype.extractReportViewStyles = function () {
        var reportViewStyles;
        if (this.fullState) {
            var jsonObject = typeof this.fullState === 'string' ? JSON.parse(this.fullState) : this.fullState;
            if (jsonObject.state.reportViewStyles) {
                reportViewStyles = report_view_styles_deserializer_1.ReportViewStylesDeserializer.fromJson(jsonObject.state.reportViewStyles);
            }
        }
        return reportViewStyles ? reportViewStyles : new report_view_styles_1.ReportViewStyles();
    };
    __decorate([
        core_1.Input('state'),
        __metadata("design:type", String)
    ], SisTabularReportDesignerComponent.prototype, "fullState", void 0);
    __decorate([
        core_1.Output('stateChange'),
        __metadata("design:type", core_1.EventEmitter)
    ], SisTabularReportDesignerComponent.prototype, "viewState", void 0);
    SisTabularReportDesignerComponent = __decorate([
        core_1.Component({
            
            selector: 'sis-tabular-report-designer',
            template: require('./sis-tabular-report-designer.component.html'),
            styles: [require('./sis-tabular-report-designer.component.css')],
            changeDetection: core_1.ChangeDetectionStrategy.OnPush
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: '<sis-tabular-report-designer [state]=\'%{state}\' (stateChange)=\'%{stateChange}\'></sis-tabular-report-designer>',
        }),
        __metadata("design:paramtypes", [view_event_service_1.ViewEventService, core_1.ChangeDetectorRef])
    ], SisTabularReportDesignerComponent);
    return SisTabularReportDesignerComponent;
}());
exports.SisTabularReportDesignerComponent = SisTabularReportDesignerComponent;
//# sourceMappingURL=sis-tabular-report-designer.component.js.map